<template>
    <div v-if="companyEmployeeList">
        <div class="grid-x align-items employee-actions">
            <div class="section-header" v-if="companyEmployeeList.length > 0">{{ `Medarbejdere (${sortedUsers.length | 0} ${showDisabledUsers ? 'in' : ''}aktiv${sortedUsers.length !== 1 ? 'e' : ''} bruger${sortedUsers.length !== 1 ? 'e' : ''})` }}</div>
            <div class="auto cell align-items flexbox-end">
                <div class="flexbox-end">
                    <strong>Vis kun inaktive brugere</strong>
                    <switches v-model="showDisabledUsers" theme="custom" type-bold="false" color="blue" style="margin-bottom: -14px; "/>
                    {{ showDisabledUsers ? 'Aktiv' : 'Ikke aktiv' }}
                </div>
                <button class="float-right button button-small" @click="openModal('administration-modal-user-' + application.value, '')">
                    <icon class="small-svg fill-white" name="user" />
                    Tilføj
                </button>
            </div>
        </div>
        <div v-if="companyEmployeeList.length > 0" class="grid-x">
            <div class="cell large-12">
                <div class="grid-x list-sort">
                    <div class="cell large-1"></div>
                    <div class="cell large-2 item flexbox" @click="sort('name')" :class="{selected: currentSort === 'name'}">
                        <span>Navn</span>
                        <div>
                            <icon v-if="currentSort === 'name'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'name'}" name="keyboard_arrow_sort" />
                        </div>
                    </div>
                    <div class="cell large-2 item flexbox" @click="sort('email')" :class="{selected: currentSort === 'email'}">
                        <span>E-mail</span>
                        <div>
                            <icon v-if="currentSort === 'email'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'email'}" name="keyboard_arrow_sort" />
                        </div>
                    </div>
                   <div class="cell large-1 item flexbox" @click="sort('phoneNumber')" :class="{selected: currentSort === 'phoneNumber'}">
                        <span>Telefonnr</span>
                        <div>
                            <icon v-if="currentSort === 'phoneNumber'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'phoneNumber'}" name="keyboard_arrow_sort" />
                        </div>
                    </div>
                    <div class="cell large-2 item flexbox" @click="sort('tags')" :class="{selected: currentSort === 'tags'}">
                        <span>Tags</span>
                        <div>
                            <icon v-if="currentSort === 'tags'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'tags'}" name="keyboard_arrow_sort" />
                        </div>
                    </div>
                    <div class="cell large-2 item flexbox" @click="sort('automaticCloseTask')" :class="{rotated: currentSortDir === 'desc' && currentSort === 'automaticCloseTask'}" name="keyboard_arrow_sort" >
                        <span>Afslutter automatisk</span>
                        <div>
                            <icon v-if="currentSort === 'automaticCloseTask'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'tags'}" name="keyboard_arrow_sort" />
                        </div>
                    </div>
                    <div class="cell large-2 item flexbox-start sort-status-tag" @click="sort('role')" :class="{selected: currentSort === 'role'}">
                        <span>Rolle</span>
                        <div>
                            <icon v-if="currentSort === 'role'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'role'}" name="keyboard_arrow_sort" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="user-feedback-list">
            <p>Ingen medarbejdere endnu.</p>
            <p>Tryk på Tilføj for at tilføje en medarbejder.</p>
        </div>
        <transition-group name="list" tag="div">
            <div v-for="user in sortedUsers" :key="user.userId">
                <div class="cell large-12">
                    <div class="grid-x list-row align-items">
                        <div class="cell large-1 flexbox-center">
                            <icon v-show="user.usersAreAssociated" class="user medium-svg fill-dark-gray" name="usergroup"/>
                            <icon v-show="!user.usersAreAssociated" class="user medium-svg fill-dark-gray" name="user"/>
                        </div>
                        <div class="cell large-2 item">
                            <span class="truncate-ellipse">{{user.name}}</span>
                            <span v-if="user.lockedOut" class="truncate-ellipse">Bruger er låst i op til to timer</span>
                            <span v-else-if="user.lastSeen > '0002-01-01T00:00:00'" class="truncate-ellipse">Seneste login: {{ user.lastSeen | formatDate }}</span>
                            <span v-else class="truncate-ellipse">Ingen login</span>
                        </div>
                        <div class="cell large-2 item">
                            <span v-if="user.email" class="truncate-ellipse">{{user.email}}</span>
                            <span v-else class="truncate-ellipse">Ingen email</span>
                        </div>
                        <div class="cell large-1 item">
                            <span v-if="user.phoneNumber" class="truncate-ellipse">{{user.phoneNumber}}</span>
                            <span v-else class="truncate-ellipse">Intet telefonnummer</span>
                        </div>
                        <div class="cell large-2 item flexbox-align-items" style="flex-wrap: wrap;">
                            <div v-for="(tag, index) in user.tagList" :key="index" class="truncate-ellipse" style="margin-bottom: 5px;">
                                <span class="tag">{{ tag.description }}</span>
                            </div>
                        </div>
                        <div class="cell large-2 item">
                            <span v-if="user.automaticCloseTask">Ja</span>
                            <span v-else>Nej</span>
                        </div>
                        <div class="cell large-2 flexbox-start item">
                            <div v-if="user.applicationGroupList && user.applicationGroupList.length > 0" class="role-status" :class="{'disabled-item': !user.activeInOrganization}">{{user.applicationGroupList | translateRoles('dk')}}
                            </div>
                            <div v-else class="role-status" :class="{'disabled-item': !user.activeInOrganization}">Ingen rolle</div>
                            <a class="flexbox-center botton-edit" title="Rediger bruger" @click="openModal('administration-modal-user-' + application.value, user)">
                                <icon class="medium-svg fill-dark-gray" name="pencil" />
                            </a>
                            <a class="flexbox-center botton-edit" title="Lås bruger op" v-if="user.lockedOut" @click="unlockUser(user)">
                                <icon class="medium-svg fill-dark-gray" name="user_unlock" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Switches from 'vue-switches'

export default {
    name: 'list-company-employee',
    components: {
        Switches
    },
    data () {
        return {
            selectedSupplyTypeCode: '',
            currentSort: 'name',
            currentSortDir: 'asc',
            showDisabledUsers: false
        }
    },
    computed: {
        ...mapGetters({
            companyEmployeeList: 'getOrganizationEmployeeList',
            application: 'getApplication'
        }),
        sortedUsers () {
            const userList = this.companyEmployeeList.filter(u => u.activeInOrganization === !this.showDisabledUsers)
            if (userList && userList.length > 0) {
                return userList.sort((a, b) => {
                    let modifier = 1
                    if (this.currentSortDir === 'desc') {
                        modifier = -1
                    }
                    if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase() || a[this.currentSort] === null) {
                        return -1 * modifier
                    }
                    if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase() || b[this.currentSort] === null) {
                        return 1 * modifier
                    }
                    return 0
                })
            } else {
                return 0
            }
        }
    },
    methods: {
        ...mapActions({
            setEmployee: 'setEmployee',
            setUnlockUser: 'setUnlockUser'
        }),
        openModal (view, user) {
            new Promise((resolve, reject) => {
                resolve(this.setEmployee(user))
            }).then(() => {
                this.$emit('open', view)
            })
        },
        unlockUser (user) {
            return new Promise((resolve, reject) => {
                resolve(this.setUnlockUser(user))
            })
        },
        sort (s) {
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
            }
            this.currentSort = s
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/list/list-company-employee.vue